import React, { useState, useEffect } from 'react';
import { Box, Container, useMediaQuery } from '@mui/material';

import './index.less';
import Header from './header';
import ChatWindow from './chatWindow';
import Sidebar from './sidebar';
import { getChatHistory, getConversationFromHistory } from '../../../api/sidebarAPI';
import { useSelection } from '../../molecules/askAsper/contexts/SelectionContext';

function transformApiResponse(apiResponse) {
    return apiResponse.reduce((acc, item) => {
        acc.push({
            content: item.user_input,
            isUser: true,
            chartData: null,
            followupQuestions: [],
            excelFileURL: '',
            pptFileURL: '',
            additional_kwargs: {},
            transparency: '',
        });

        const answerObject = {
            content: item.content,
            thread_id: item.thread_id,
            run_id: item.run_id,
            isUser: false,
            chartData: item.additional_kwargs?.recharts_json || null,
            followupQuestions: item.additional_kwargs?.followup_questions
                ? JSON.parse(item.additional_kwargs.followup_questions)
                : [],
            excelFileURL: null,
            pptFileURL: '',
            additional_kwargs: item.additional_kwargs || {},
            transparency: item.additional_kwargs?.transparency || '',
        };
        acc.push(answerObject);

        return acc;
    }, []);
}

function ChatView() {
    const { handleResetSelection } = useSelection();
    const [resetConversation, setResetConversation] = useState(false);
    const [resetBtnDisabled, setResetBtnDisabled] = useState(true);
    const [startNewConversation, setStartNewConversation] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [conversationData, setConversationData] = useState([]);
    const [chatFromHistoryData, setChatFromHistoryData] = useState([]);
    const [selectedThreadID, setSelectedThreadID] = useState('');
    const [chatMessages, setChatMessages] = useState([]);
    const [historyData, setHistoryData] = useState([]);
    const isMobile = useMediaQuery('(max-width:768px)');
    const [isLoadingHistory, setIsLoadingHistory] = useState(true);
    // Handle responsive behavior
    useEffect(() => {
        fetchChatHistory();
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setSidebarOpen(false);
            } else {
                setSidebarOpen(true);
            }
        };

        // Initial check
        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {
        async function fetchData() {
            if (chatFromHistoryData.length) {
                const transformedData = await transformApiResponse(chatFromHistoryData);
                console.log(transformedData, 'transformedData');
                setConversationData(transformedData);
            }
        }
        fetchData();
    }, [chatFromHistoryData]);

    const fetchChatHistory = async () => {
        setIsLoadingHistory(true);
        try {
            const res = await getChatHistory();
            console.log(res, 'res');
            setHistoryData(res);
        } catch (error) {
            console.error('Error fetching chat history:', error);
            setHistoryData([]);
        } finally {
            setIsLoadingHistory(false); // Set loading to false after fetching (success or error)
        }
    };

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleReset = (value) => {
        setResetConversation(value);
    };

    const handleEnableDisableResetBtn = (value) => {
        setResetBtnDisabled(value);
    };
    const fetchConversationFromHistory = async (thread_id) => {
        try {
            const res = await getConversationFromHistory(thread_id);
            console.log(res, 'conversation response');
            setChatFromHistoryData(res);
        } catch (error) {
            console.error('Error fetching chat history:', error);
            setChatFromHistoryData([]);
            setSelectedThreadID('');
        }
    };
    const handleHistoryClick = (thread_id) => {
        // alert(`Hi!!!!!!!!!!!!!!!!  ${thread_id}`)
        //call api here
        setSelectedThreadID(thread_id);
        fetchConversationFromHistory(thread_id);
        handleResetSelection();
    };
    const handleMessagesChanged = (newMessages) => {
        console.log('Chat messages updated in parent:', newMessages);
        setChatMessages(newMessages);
        // if (newMessages.length == 0) {
        setStartNewConversation(false);
        // }
        // Perform any other actions with the new messages
    };
    const handleStartButtonClick = () => {
        setStartNewConversation(true);
        setSelectedThreadID('');
        handleResetSelection();
    };

    return (
        <Container
            maxWidth={false}
            className={`chat-view-wrapper ${sidebarOpen ? 'sidebar-open' : ''}`}
            disableGutters
            sx={{
                padding: 0,
                position: 'relative',
                height: 'calc(100vh - 150px)',
                overflow: 'hidden',
            }}
        >
            <Sidebar
                open={sidebarOpen}
                toggleSidebar={toggleSidebar}
                historyData={historyData}
                handleHistoryClick={handleHistoryClick}
                selectedThreadID={selectedThreadID}
                chatMessages={chatMessages}
                handleStartNewButtonClick={() => {
                    handleStartButtonClick();
                }}
                isLoadingHistory={isLoadingHistory}
            />
            <Box
                className="chatbot-container"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    transition: 'left 0.3s ease, width 0.3s ease',
                }}
            >
                <Header
                    handleReset={handleReset}
                    resetBtnDisabled={resetBtnDisabled}
                    toggleSidebar={toggleSidebar}
                    sidebarOpen={sidebarOpen}
                />
                <ChatWindow
                    resetConversation={resetConversation}
                    handleReset={handleReset}
                    handleEnableDisableResetBtn={handleEnableDisableResetBtn}
                    sidebarOpen={sidebarOpen}
                    conversationData={conversationData}
                    selectedThreadID={selectedThreadID}
                    onMessagesChanged={handleMessagesChanged}
                    startNewConversation={startNewConversation}
                    fetchChatHistory={fetchChatHistory}
                />
            </Box>
        </Container>
    );
}

export default ChatView;
